import { ReduxProvider } from '@tmapy/redux';
import { IntlProvider } from '@tmapy/intl';
import { DevToolsContainer } from '@tmapy/devtools';

import { Router } from './Router';

export const App: React.FC<{}> = () => {
  return (
    <ReduxProvider>
      <IntlProvider>
        <DevToolsContainer />
        <Router />
      </IntlProvider>
    </ReduxProvider>
  );
};
